import Tippy, { TippyProps } from '@tippyjs/react';

import styled from 'styled-components';
import { Colors } from '../Style';

export interface TippyDropdownProps extends TippyProps {
	children?: TippyProps['children'];
	options: React.ReactNode;
	open: boolean;
	setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function TippyDropdown(props: TippyDropdownProps) {
	const { children, options, open, setOpen, ...rest } = props;

	return (
		<Tooltip
			content={<DropdownContainer>{options}</DropdownContainer>}
			offset={[0, 0]}
			duration={[0, 0]}
			placement={'bottom-start'}
			interactive={true}
			visible={open}
			onClickOutside={() => setOpen(false)}
			appendTo={document.body}
			{...rest}
		>
			{children}
		</Tooltip>
	);
}

export const DropdownContainer = styled.div`
	display: flex;
	flex-direction: column;

	a {
		color: #5c5c5c;
		background: transparent;
		text-decoration: none !important;
		padding: 0.5rem 1rem;
		font-weight: 500;

		&:hover {
			background: ${Colors.gray1};
			cursor: pointer;
		}

		&:focus {
			outline: none;
			color: black;
		}

		&.active {
			color: ${Colors.gray7};
			background: ${Colors.gray2};

			&:hover {
				background: ${Colors.gray2};
				cursor: default;
			}
		}
	}
`;

export const Tooltip = styled(Tippy)`
	background: ${Colors.white};
	color: white;
	padding: 0;
	border-radius: 0.25rem;

	min-width: 150px;

	.tippy-content {
		padding: 0;
	}

	.tippy-arrow {
		color: ${Colors.white};
		display: none;
	}

	box-shadow: 0px 0px 25px #00000040;
`;

export const DropdownDivider = styled.div`
	height: 1px;
	width: 100%;
	background: ${Colors.gray3};
	margin-block: 0.25rem;
`;

export function DropdownTitle(props: { children: React.ReactNode }) {
	return (
		<DropdownTitleContainer>
			<DropdownTitleText>{props.children}</DropdownTitleText>
		</DropdownTitleContainer>
	);
}

const DropdownTitleContainer = styled.div`
	padding: 0.3rem 0.7rem;
`;

// title with a horizontal line after it
const DropdownTitleText = styled.div`
	display: flex;
	align-items: center;
	font-weight: 500;
	color: ${Colors.gray7};
	font-size: 10px;
	text-transform: uppercase;

	&:after {
		content: '';
		display: block;
		height: 1px;
		background: ${Colors.gray3};
		margin: 0.3rem 0 0.3rem 0.5rem;
		align-self: stretch;
		flex-grow: 1;
	}
`;
